import { Command } from 'cmdk';

import { Tag } from '../../../../cdl/Tag/Tag';
import { translate } from '../../../helpers/translate.helper';
import { useGroupContext } from '../../../hooks/useGroupContext';
import { GroupContextType } from '../../../utils/groupContextType';
import { useShortcutMenu } from '../../hooks/useShortcutMenu';
import { CommandItem } from '../CommandItem';
import { CommandListNestedRouterPathEnum } from '../commandRoutes';

export const GroupTypeSelection = () => {
    const { setGroupContextActionType, setPages, setSearch } = useShortcutMenu();
    const { clearGroupContext, groupId, name } = useGroupContext();

    return (
        <Command.List>
            {groupId ? (
                <CommandItem
                    destructive
                    trailingVisual={name ? <Tag variant="default">{name}</Tag> : null}
                    onSelect={() => {
                        clearGroupContext();
                        setSearch('');
                        setPages([CommandListNestedRouterPathEnum.NAVIGATE]);
                        setGroupContextActionType(null);
                    }}
                >
                    {translate('shortcutMenu.removeContext')}
                </CommandItem>
            ) : null}
            <Command.Group heading={translate('shortcutMenu.selectGroup')}>
                <CommandItem
                    value={GroupContextType.CUSTOMER_GROUP}
                    onSelect={() => {
                        setSearch('');
                        setGroupContextActionType(GroupContextType.CUSTOMER_GROUP);
                    }}
                >
                    {translate('shortcutMenu.customer')}
                </CommandItem>
                <CommandItem
                    value={GroupContextType.SUPPLIER_GROUP}
                    onSelect={() => {
                        setSearch('');
                        setGroupContextActionType(GroupContextType.SUPPLIER_GROUP);
                    }}
                >
                    {translate('shortcutMenu.supplier')}
                </CommandItem>
            </Command.Group>
        </Command.List>
    );
};
